import { ComponentConfig } from "@measured/puck";
import WysiwygField from "../../Fields/WysiwygField";
import TextBlockRender from "./AnnotationBlockRender";
import AnnotationBlockRender from "./AnnotationBlockRender";

const AnnotationBlock: ComponentConfig<{ text: string }> = {
    fields: {
        // @ts-ignore
        text: {
            // @ts-ignore
            ...WysiwygField.fields.editor,
            label: 'Tekst'
        },
    },
    render: (props) => (
        <AnnotationBlockRender {...props} />
    ),
}

export default AnnotationBlock;
